<div class="plan-selector">
    <span>Scale: {{ scaleRatio ? scaleRatio : 'Manual' }}</span>
    <span class="measurement-title fw-bold">{{ measurement?.description }}</span>
</div>
